import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Guid } from 'guid-typescript';
import { ApplicationService } from '../../../common/services/application.service';
import { ApplicationReview } from '../../../common/models/application';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  imports: [RouterModule, 
          MatCardModule,
          MatMenuModule,
          MatButtonModule,
          MatTableModule,
          MatPaginatorModule,
          MatTooltipModule,
          MatIconModule,
          MatDialogModule,
          MatSnackBarModule,
          CommonModule
      ]
})
export class ReviewsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  applicationId!: Guid;
  reviews: ApplicationReview[] = [];
  
  constructor(
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
  ) {}

  ngOnInit() {
    const appId = this.route.snapshot.paramMap.get('applicationId');
    if (appId) {
      this.applicationId = Guid.parse(appId);
      this.applicationService.getReviews(this.applicationId).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data) => {
          this.reviews = data;
        },
        error: (err) => {
          console.error('Error fetching reviews', err);
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}